import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import * as fromConfirmation from './../store/selectors';
import * as fromCompleteOrder from '@complete-order/store/reducers';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  constructor(
    public readonly store?: Store<fromCompleteOrder.CompleteOrderState>,
    public readonly fb?: UntypedFormBuilder
  ) {}

  readonly offerTakenData$ = this.store.select(
    fromConfirmation.getOrderTakenData
  );
}
